<template>
    <div class="row">
        <div class="col-md-12">
            <button v-if="currency != '' && userCountry == '5'" class="btn btn-secondary m-2 mx-auto" @click="confirmPayMp()">Pagar {{currency}} {{ formatNumber(price) }}</button>
            <button v-if="currency != '' && userCountry != '5'" class="btn btn-secondary m-2 mx-auto" @click="confirmPayStripe()">Pagar USD {{ formatNumber(price) }}</button>
            <p class="text-danger" v-if="error">No se pudo realizar el pago. Prueba con otra tarjeta o comunicate con tu Banco.</p>
        </div>
    </div>
    <div class="payment-container" id="testPay" v-show="pay">
        <button id="closePaymentPopUp" class="btn btn-outline-primary btn-close-popup" @click="hidePasarela()"><i class="las la-times"></i></button>
        <iframe  :src="buttonPasarela"></iframe>
    </div>
</template>
<script>
import axios from "axios";
let url;
export default {
    props: ['difPayPlan'],
    data(){
        return{
            dataReceiver: '',
            userPlan: 0,
            userPlanDuration: 0,
            userCountry: 0,
            price: 0,
            currency: '',
            title: 'Comisiones por ventas desde buscador', 
            pasarela: '',
            currency: '',
            pay: false,
            error: false,
            buttonPasarela: '',
            payId: '',
            hidecontent: false,
        }
    },
    name: 'paymment-plans',
    mounted: function () {  
        if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
            url = 'https://api.animasana.net'
        }else if(window.location.host == 'api-qa.animasana.net'){
            url = 'https://api-qa.animasana.net' 
        }else{
            url = 'https://api-qa.animasana.net'
        }   
        
        if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
            this.dataReceiver = localStorage.getItem('corporativeIn');
        }else{
            this.dataReceiver = localStorage.getItem('token');
        }
        var data = JSON.parse(localStorage.getItem('userData'));
        this.userPlan = data.userPlan;
        this.cicle = data.userCicle;
        this.userCountry = data.userCountry;
        this.findUserData();
        
    },
    beforeDestroy: function () {
       
    },
    methods:{
        formatNumber(value) {
            if (!value) return "0";
            
            // Detectar formato según país
            let locale = "es-AR"; // por defecto argentino
            if (this.userCountry == 55) {
            locale = "en-US"; // formato americano
            }

            // Asegurarse de que sea número
            const number = Number(value);

            // Formatear
            return new Intl.NumberFormat(locale).format(number);
        },
        findUserData(){  
            if (localStorage.getItem("corporativeIn") !== null && localStorage.getItem("corporativeIn") !== "") {
                this.dataReceiver = localStorage.getItem('corporativeIn');
            }else{
                this.dataReceiver = localStorage.getItem('token');
            }
            var data = JSON.parse(localStorage.getItem('userData')); 
            this.userPlan = data.userPlan;
            this.userPlanDuration = data.days_plan;
            this.userCountry = data.userCountry; 
            this.findPlans();
            return
        },
        async findPlans(){     
            var payload = {
                action: 'find-plans',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.dataReceiver, 
                userCountry: this.userCountry,     
                isRegister: false,
                showFree: 'NO'
            }       
            await axios.post('/index.php', payload).then(result => {
                const plans = result.data;
                const plan = plans.find(p => Number(p.plan_id) === Number(this.userPlan) && Number(p.duration) === Number(this.userPlanDuration));
                if (plan) {
                    const nombre = plan.name;
                    var duration = '';
                    if(this.userPlanDuration == 180){
                        duration = ' semestral.';
                    }else if(this.userPlanDuration == 365){
                        duration = ' anual.';
                    }
                    if(this.difPayPlan != 0){
                        this.price = this.difPayPlan;
                    }else{
                        this.price = plan.real_price;
                    }
                    
                    this.currency = plan.currency;
                    this.title = 'Animasana - Pago de Plan ' + nombre + duration;      
                }
                
            })
            .catch(error => {
               
            })     
        },

        hidePasarela(){
            this.pay=false; 
            this.hidecontent = false;    
            document.querySelector('html').classList.remove('overflow-hidden');    
        },
        confirmPayStripe(){ 
            //localStorage.setItem('payPlan', JSON.stringify({pasarela: 'stripe', totalAmmount: this.price, currency: 'USD', user: this.dataReceiver}));
            this.pasarela = 'stripe';
            this.openPasarela();
        },
        confirmPayMp(){ 
            //localStorage.setItem('payPlan', JSON.stringify({pasarela: 'mp', totalAmmount: this.price, currency: 'ARS', user: this.dataReceiver}));
            this.pasarela = 'mp';
            this.openPasarela();
        },
        openPasarela(){ 
            if(this.userCountry == '5'){
                this.mp();
            }else{
                this.stripe();
            }
        },
        async mp(){
            this.buttonPasarela = url + '/pasarelas/mp-option-ar-plan.php?browserCountry='+this.$route.params.browserCountry
            +'&userLang='+this.$route.params.userLang+'&urlcode='+window.location.host+'&dataReceiver='+this.dataReceiver+'&item='+localStorage.getItem('token')+'&price='+this.price+'&currency='+this.currency
            +'&back='+window.location.href+"&description="+this.title+"&short=Animasana";
            this.pay = true;
            this.hidecontent = true;
            document.querySelector('html').classList.add('overflow-hidden');          
        },
        async stripe(){
            this.buttonPasarela = url + '/pasarelas/stripe-option-plan.php?browserCountry='+this.$route.params.browserCountry
            +'&userLang='+this.$route.params.userLang+'&urlcode='+window.location.host+'&dataReceiver='+this.dataReceiver+'&item='+localStorage.getItem('token')+'&price='+this.price+'&currency=USD'
        +'&back='+window.location.href+"&description="+this.title+"&short=Animasana";
            this.pay = true;
            this.hidecontent = true;
            document.querySelector('html').classList.add('overflow-hidden');          
        },
        
        
    }
  }
</script>
